import { useEffect, useState } from "react";
import {
  BalancerError,
  BalancerErrorCode,
  BalancerSDK,
  BalancerSdkConfig,
  Network,
  SubPoolMeta,
} from "@balancer-labs/sdk";
import { getRpcUrl, ARBITRUM } from "config/chains";
import { useChainId } from "lib/chains";
import { getContractAddress } from "config/contracts";

const POOL_ID = "0x88e2c969e2a1c69c16d1dcd9f8acde4c6ab3838a0002000000000000000004c1";

export const useFoxPrice = () => {
  const [price, setPrice] = useState<string | SubPoolMeta>("");
  const [isPriceLoading, setIsPriceLoading] = useState<boolean>(false);
  const { chainId } = useChainId();
  // Balancer can give us a price only for the MAINNET Fox token address
  const foxTokenAddress = getContractAddress(ARBITRUM, "Fox");

  const CONFIG: BalancerSdkConfig = {
    network: Network.ARBITRUM,
    rpcUrl: getRpcUrl(chainId) as string,
  };
  const [BALANCER] = useState(new BalancerSDK(CONFIG));

  useEffect(() => {
    if (price) {
      return;
    }

    (async () => {
      setIsPriceLoading(true);
      const fetchSpotPrice = async () => {
        const pool = await BALANCER.pools.find(POOL_ID);

        if (!pool) {
          throw new BalancerError(BalancerErrorCode.POOL_DOESNT_EXIST);
        }

        const poolToken = pool.tokens.find((token) => token.address.toLowerCase() === foxTokenAddress.toLowerCase());

        if (poolToken) {
          const { latestUSDPrice } = poolToken.token as SubPoolMeta;
          latestUSDPrice && setPrice(latestUSDPrice);
        }
      };

      foxTokenAddress && (await fetchSpotPrice());
      setIsPriceLoading(false);
    })();
  }, [BALANCER, foxTokenAddress, price]);

  return {
    foxPrice: price as string,
    isPriceLoading,
  };
};
